import React, { useEffect, useState } from 'react';

const EwayBillAuth = () => {

  const [auth, setAuth] = useState(null);
  const [newEWB, setNewEWB] = useState(null);
  const [checkEWB, setCheckEWB] = useState(null);

  
    const fetchData = async () => {
      const url = "https://apisandbox.whitebooks.in/ewaybillapi/v1.03/authenticate?email=ajith%40sninfoserv.com&username=BVMGSP&password=Wbooks%400142";

      const headers = {
        "accept": "*/*",
        "ip_address": "157.51.52.164",
        "client_id": "EWBSc3e8534b-bbaa-4e91-aecd-4eac1c05512a",
        "client_secret": "EWBS6aebb03c-cb91-4e9f-94cc-c1d0517d9b95",
        "gstin": "29AAGCB1286Q000"
      };

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setAuth(data);
        //console.log("Auth Response:", data);
      } catch (error) {
        console.error("Error during API call:", error);
      }
    };

    
    const generateEwayBill = async () => {
      const url = "https://apisandbox.whitebooks.in/ewaybillapi/v1.03/ewayapi/genewaybill?email=ajith%40sninfoserv.com";

      const headers = {
        "accept": "*/*",
        "ip_address": "157.51.52.164",
        "client_id": "EWBSc3e8534b-bbaa-4e91-aecd-4eac1c05512a",
        "client_secret": "EWBS6aebb03c-cb91-4e9f-94cc-c1d0517d9b95",
        "gstin": "29AAGCB1286Q000",
        "Content-Type": "application/json"
      };

      const payload = {
        supplyType: "O",
        subSupplyType: "1",
        subSupplyDesc: " ",
        docType: "INV",
        docNo: "TRC/123123",
        docDate: "09/07/2025",
        fromGstin: "29AAGCB1286Q000",
        fromTrdName: "welton",
        fromAddr1: "2ND CROSS NO 59 19 A",
        fromAddr2: "GROUND FLOOR OSBORNE ROAD",
        fromPlace: "FRAZER TOWN",
        actFromStateCode: 29,
        fromPincode: 560001,
        fromStateCode: 29,
        toGstin: "nil",
        toTrdName: "sthuthya",
        toAddr1: "Shree Nilaya",
        toAddr2: "Dasarahosahalli",
        toPlace: "Beml Nagar",
        toPincode: 263652,
        actToStateCode: 5,
        toStateCode: 5,
        transactionType: 4,
        dispatchFromGSTIN: "29AAAAA1303P1ZV",
        dispatchFromTradeName: "ABC Traders",
        shipToGSTIN: "nil",
        shipToTradeName: "XYZ Traders",
        totalValue: 56099,
        cgstValue: 0,
        sgstValue: 0,
        igstValue: 300.67,
        cessValue: 400.56,
        cessNonAdvolValue: 400,
        totInvValue: 57200.23,
        transMode: "1",
        transDistance: 128,
        transporterName: "",
        transporterId: "Nill",
        transDocNo: "12",
        transDocDate: "",
        vehicleNo: "APR3214",
        vehicleType: "R",
        itemList: [
          {
            productName: "Wheat",
            productDesc: "Wheat",
            hsnCode: 1001,
            quantity: 4,
            qtyUnit: "BOX",
            taxableAmount: 56099,
            sgstRate: 0,
            cgstRate: 0,
            igstRate: 3,
            cessRate: 0
          }
        ]
      };

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setNewEWB(result);
        console.log("E-way Bill Generated:", result);
      } catch (error) {
        console.error("Failed to generate e-way bill:", error);
      }
    };

    const fetchEwayBill = async () => {
      const url = `https://apisandbox.whitebooks.in/ewaybillapi/v1.03/ewayapi/getewaybill?email=ajith%40sninfoserv.com&ewbNo=${newEWB?.ewayBillNo}`;

      const headers = {
        "accept": "*/*",
        "ip_address": "157.51.52.164",
        "client_id": "EWBSc3e8534b-bbaa-4e91-aecd-4eac1c05512a",
        "client_secret": "EWBS6aebb03c-cb91-4e9f-94cc-c1d0517d9b95",
        "gstin": "29AAGCB1286Q000"
      };

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setCheckEWB(data);
        console.log("E-way Bill Info:", data);
      } catch (error) {
        console.error("Error fetching e-way bill:", error);
      }
    };


  useEffect(() => {
    //fetchData();
    generateEwayBill();
    fetchEwayBill();
  }, []);

  return (
    <div>
      <h1>E-way Bill Authentication</h1>
      <p>{auth?.status_cd}</p> 
      <p>{auth?.status_desc}</p> 
      <p>{newEWB?.status_cd}</p> 
      <p>{newEWB?.status_cd === 1 ? newEWB?.ewayBillNo : ''}</p> 
      <p>{checkEWB?.status_cd}</p> 
      <p>{checkEWB?.status_cd === 1 ? checkEWB?.genMode : ''}</p> 

      {/* <div className="row">
      
                <div className="col-sm-2 mt-4">
                  {getData?.eInvData?.length > 10 && (
                      <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <QRCodeCanvas value={getData?.eInvData} size={140} />
                        <small>E-Invoice</small>
                      </div>
                    )}
                </div>
      
                <div className="col-sm-8 text-center fs-13">
                    <img src={Logo} width="150px" />
                  <h4 style={{ fontWeight: "600" }}>
                    {companyData?.companyName}
                  </h4>
                  <address>
                    {companyData?.companyAddress1}, {companyData?.companyAddress2}, {companyData?.companyLocation} <br />
                    {companyData?.companyCity}, {companyData?.companyState} - {companyData?.companyZip} <br />
                    GSTIN : {companyData?.companyGst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    State : {companyData?.companyState} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    Code : {companyData?.code} <br />
                    Phone : {companyData?.companyPhone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                    Email : {companyData?.companyEmail}
                  </address>
                </div>
      
                <div className="col-sm-2">
                  <div style={{ marginTop: "-10px", marginBottom: "7px" }}>
                  <small style={{fontSize: '9px'}}>( ORIGINAL FOR RECIPIENT )</small>
                </div>
                  {payable && payable > 0 && (
                    <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                      <QRCodeCanvas value={generateUpiLink()} size={140} />
                      <small>Payment</small>
                    </div>
                  )}
                </div> 
      
              </div>*/}
              
    </div>
  );
};

export default EwayBillAuth;
